import { lazy } from "react";
import { PATHS } from "@/lib/router";

const PeerCompanyListPage = lazy(() =>
  import("./pages/PeerCompanyListPage").then((module) => ({
    default: module.PeerCompanyListPage,
  })),
);

export const benchmarkingRoutes = [
  {
    path: PATHS.PEER_COMPANIES,
    element: <PeerCompanyListPage />,
    handle: {
      permission: { resource: "peer_company", action: "view" },
      requiredCompanyFeature: "allowAssetList",
    },
  },
];
